import { useNavigate } from "react-router-dom";
import notFoundImage from "../images/404_page.png";
import { t } from "i18next";
import { getLocalStorageMenuItem } from "../utility";

const NotFound = () => {
  const type = getLocalStorageMenuItem("type");
  const navigate = useNavigate();

  const backHome = () => {
    if (type === "user" || type === "admin") {
      navigate("/");
    } else {
      navigate(0);
    }
  };

  return (
    <div className="wrap-error min-vh-100 primary-background">
      <div>
        <img src={notFoundImage} alt="Not Found Image" />
      </div>
      <div className={`text-center m-auto secondary-color`}>
        <h1 className="text-center">
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </h1>
        <h5 className="head-font">{t("Oops! Page not found")}</h5>
        <p className="mb-4 sub-font">
          {t("we are sorry, but the page you requested was not found")}
        </p>
        <button
          className="btn btn-dark button-height-sm head-font"
          title="home url"
          onClick={backHome}
        >
          {t("Go home")}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
